import React, { useState, useEffect, useCallback, useRef } from 'react';
import { getData, updateData} from '../../../services/management/accommodation/verifiedAccommodationServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Swal from 'sweetalert2';
import Spinner from '../../../components/Spinner';


const VerifiedAccommodation = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ 
    id: '',
    pr_id : '',
    accommodation_status : '',
    first_name : '',
    last_name : '',
    occupancy: '',
    no_of_nights : '',
    accompany_name : '',
    check_in: '',
    check_out: '',
    remarks: '',
    hotel_name: '',
    conf_shortname: '',
    sub_domain: '',
    series: '',
    venue: '',
    confirmation_no: '',
    verified: ''
    });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const debounceTimeoutRef = useRef(null);  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  // Filter States
  const [seriesFilter, setSeriesFilter] = useState('');
  const [subDomainFilter, setSubDomainFilter] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [hotelNameFilter, setHotelNameFilter] = useState('');
  const [venueFilter, setVenueFilter] = useState('');

  
  // Fetch data list
        const fetchData = useCallback(async () => {
            setLoading(true);
            try {
            const filters = {};
            if (subDomainFilter) filters.sub_domain = subDomainFilter;
            if (hotelNameFilter) filters.hotel_name = hotelNameFilter;
            if (venueFilter) filters.venue = venueFilter;
            if (seriesFilter) filters.series = seriesFilter;
        
              const params = {
                verified: 2,
                page: currentPage,
                limit: rowsPerPage,
                search: debouncedSearch,
                filters,
              };
        
              const response = await getData(params);
              // ✅ Console log the full API response
              console.log('Fetched Data:', response);
              setDataList(response.rows);
              setTotalRows(response.count);
            } catch (error) {
              console.error('Failed to fetch data:', error);
            } finally {
              setLoading(false);
            }
        }, [currentPage, rowsPerPage, debouncedSearch, subDomainFilter, hotelNameFilter,venueFilter, seriesFilter]);
           
    // Debounce Effect
      useEffect(() => {
        if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
    
        debounceTimeoutRef.current = setTimeout(() => {
          setDebouncedSearch(searchText);
          setCurrentPage(1); // reset page only when actual search triggered
        }, 600); // 500ms debounce delay
    
        return () => clearTimeout(debounceTimeoutRef.current);
      }, [searchText]);
    
      useEffect(() => {
        const fetchDataAsync = async () => {
          setLoading(true); 
          await fetchData();
          // Optional 2 second delay
          await new Promise((resolve) => setTimeout(resolve, 1000));
          setLoading(false); 
        };

        fetchDataAsync();
      }, [fetchData]);

    const handleSubmit = async () => {
    try {
      // Show confirmation before proceeding
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to cancel this accommodation?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it',
        cancelButtonText: 'No',
        reverseButtons: true,
      });

      // If user clicks "No", exit function
      if (!result.isConfirmed) {
        return;
      }

      // Proceed only if confirmed
      if (modalType === 'view') {
        const updatedForm = { ...form, verified: 3 }; // Change verified status to cancelled
        await updateData(updatedForm);
      }

      await fetchData();
      setShowModal(false);

      // Success message
      Swal.fire({
        icon: 'success',
        title: 'Cancelled',
        text: 'Accommodation has been successfully cancelled.',
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error('Error during form submission:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while submitting the form!',
      });
    }
  };


  const openModal = (type, data = { id: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  const columns = [
      {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
      },
      {
          name: 'SubDomain',
          selector: (row) => row.sub_domain,
          sortable: true,
      },
      {
      name: 'Series',
      selector: (row) => {
          // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
          const date = new Date(row.series);
          
          // Format as "2025-11 Nov 2025"
          const year = date.getFullYear();
          const month = date.getMonth(); // 0-based index, so we add 1
          const months = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ];
      
      return ` ${months[month]} ${year}`;
    },
    sortable: true,
    },
    {
        name: 'Shortname',
        selector: (row) => row.conf_shortname,
        sortable: true,
    },
       
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('view', row)}>view</Button>
        </div>
      ),
    },
  ];
  
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            {/* Dropdown for Filters */}
             <div className="col-md-2">
              <span>Series</span>
              <select className="form-control" value={seriesFilter} onChange={(e) => setSeriesFilter(e.target.value)}>
                <option value="">All Series</option>
                {Array.from(new Set(dataList.map((item) => item.series))).map((series, idx) => (
                  <option key={idx} value={series}>{series}</option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <span>Hotel Name</span>
              <select className="form-control" value={hotelNameFilter} onChange={(e) => setHotelNameFilter(e.target.value)}>
                <option value="">All Hotels</option>
                {Array.from(new Set(dataList.map((item) => item.hotel_name))).filter(Boolean).map((hotel, idx) => (
                  <option key={idx} value={hotel}>{hotel}</option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <span>Venue</span>
              <select className="form-control" value={venueFilter} onChange={(e) => setVenueFilter(e.target.value)}>
                <option value="">All Venues</option>
                {Array.from(new Set(dataList.map((item) => item.venue))).filter(Boolean).map((venue, idx) => (
                  <option key={idx} value={venue}>{venue}</option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <span>Sub Domain</span>
              <select className="form-control" value={subDomainFilter} onChange={(e) => setSubDomainFilter(e.target.value)}>
                <option value="">All Subdomains</option>
                {Array.from(new Set(dataList.map((item) => item.sub_domain))).map((subDomain, idx) => (
                  <option key={idx} value={subDomain}>{subDomain}</option>
                ))}
              </select>
            </div>
          </div>        
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4">Conference Management / Accommodation / Verified Accommodation</p>
            </div>
          </div>

          <DataTable
                columns={columns}
                data={dataList}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={rowsPerPage}
                onChangePage={handlePageChange}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                highlightOnHover
                responsive
                striped
                subHeader
                subHeaderComponent={
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearchChange}
                  />
                }
            />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add ' : 'View'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Table striped bordered hover responsive className="table-sm">
                <thead>
                     
                    </thead>
                    <tbody>
                    </tbody>
                    <br></br>
                    <thead>
                      <tr>
                        <th className='bg-secondary text-white' colSpan={2}>Accommodation Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>First Name</td>
                        <td>{form.first_name	}</td>
                      </tr>
                      <tr>
                        <td>Last Name</td>
                        <td>{form.last_name}</td>
                      </tr>
                      <tr>
                        <td>Occupancy</td>
                        <td>{form.occupancy}</td>
                      </tr>
                      <tr>
                        <td>No of Nights</td>
                        <td>{form.no_of_nights}</td>
                      </tr>
                      <tr>
                        <td>Accommodation Status</td>
                        <td>{form.accommodation_status}</td>
                      </tr>                     
                      <tr>
                        <td>Accompany Name</td>
                        <td>{form.accompany_name}</td>
                      </tr>
                      <tr>
                        <td>Check In</td>
                        <td>{form.check_in}</td>
                      </tr>
                      <tr>
                        <td>Check out</td>
                        <td>{form.check_out}</td>
                      </tr>
                      <tr>
                        <td>Remarks</td>
                        <td>{form.remarks}</td>
                      </tr>
                      <tr>
                        <td>Hotel Name</td>
                        <td>{form.hotel_name}</td>
                      </tr>
                      <tr>
                        <td>Shortname</td>
                        <td>{form.conf_shortname}</td>
                      </tr>
                      <tr>
                        <td>SubDomain</td>
                        <td>{form.sub_domain}</td>
                      </tr>
                      <tr>
                        <td>Series</td>
                        <td>{form.series}</td>
                      </tr>
                      <tr>
                        <td>Confirmation No</td>
                        <td>{form.confirmation_no}</td>
                      </tr>            
                    </tbody>
                    <br></br>
                  </Table>
             
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={handleSubmit}>
                Cancel Accommodation
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default VerifiedAccommodation;
